import React from "react";
import { Colors } from "src/assets/colors/Colors";

export default (props) => (
    <div style={{
        position: 'absolute',
        top: '15%',
    }}>
        <strong style={{color: props.value ? Colors.AMARILLO_MOSTAZA : Colors.GREEN_SWITCH_ACTIVE}}>{props.value ? 'Editar' : 'Crear'}</strong>
    </div>
);